import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EventType_Update, LL_H_C, LL_V_L, ModuleFE_Dialog, ModuleFE_Toaster, performAction, TS_Dialog, TS_Radio } from '@nu-art/thunderstorm-frontend/index';
import { BadImplementationException, cloneObj, dbObjectToId, filterDuplicates, filterInstances, flatArray, MUSTNeverHappenException, removeFromArrayByIndex, removeItemFromArray, voidFunction } from '@nu-art/ts-common';
import './Dialog_MultiVar_Editor.scss';
import { Component_TagEditor, Component_VariableSelector, ConfigKeyFE_DiseasesTagId, ConfigKeyFE_DiseasesViewsTagId, ConfigKeyFE_SourceTagId, handleError, ModuleFE_Tag, ModuleFE_Variable, QToastContent, VariableWrapper } from '@app/hcs-frontend';
import { DPDropDowns } from '../../shared-components/index.js';
import { ICONS } from '@app/styles';
import { ModuleFE_DiseaseProfile, ModuleFE_DiseaseView, ModuleFE_MultiVar } from '../../../_entity.js';
export class Dialog_MultiVar_Editor extends TS_Dialog {
    //######################### Static #########################
    static defaultProps = {
        dialogId: 'dialog-multivar-editor',
    };
    static show = (diseaseView, diseaseProfileId, mv) => {
        const multiVar = mv ? cloneObj(mv) : {
            diseaseProfileId: diseaseProfileId,
            referenceIds: [],
            variables: [],
            _firstVarId: '',
            _variableIds: [],
            _tagIds: []
        };
        ModuleFE_Dialog.show({ content: _jsx(Dialog_MultiVar_Editor, { diseaseView: diseaseView, multiVar: multiVar }), closeOverlayOnClick: () => false });
    };
    static showForVariable(multiVar, columnIndex) {
        ModuleFE_Dialog.show({
            content: _jsx(Dialog_MultiVar_Editor, { multiVar: cloneObj(multiVar), attributeeIndex: -1, attributeOrColumnIndex: columnIndex })
        });
    }
    static showForAttributes(multiVar, attributeeIndex, attributeIndex) {
        ModuleFE_Dialog.show({
            content: _jsx(Dialog_MultiVar_Editor, { multiVar: cloneObj(multiVar), attributeeIndex: attributeeIndex, attributeOrColumnIndex: attributeIndex })
        });
    }
    //######################### Life Cycle #########################
    __onDeleteConflicts(entity, conflictingIds) {
        this.closeDialog();
    }
    __onVariableUpdated(...params) {
        if (params[0] !== EventType_Update)
            return;
        if (this.getSelectedVariable()?._id !== params[1]._id)
            return;
        this.forceUpdate();
    }
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.editingIndex = nextProps.attributeeIndex === undefined
            ? 0
            : state.editingIndex || nextProps.attributeOrColumnIndex || nextProps.multiVar.variables.length;
        state.isChief ||= Dialog_MultiVar_Editor.isChief(nextProps);
        if (!this.state && this.isEditing())
            state.diseaseView = nextProps.diseaseView;
        state.diseaseCategoryId = ConfigKeyFE_DiseasesTagId.get();
        state.sourceTagId = ConfigKeyFE_SourceTagId.get();
        state.tags = VariableWrapper.dbTagsToUI(nextProps.multiVar.variables[state.editingIndex]?.tagIds || []);
        return state;
    }
    //######################### Logic #########################
    onVariableSelected = (variable) => {
        this.props.multiVar.variables[this.state.editingIndex] = {
            variableId: variable._id,
            tagIds: [],
        };
        if (this.state.editingIndex !== 0)
            return this.reDeriveState({ tags: undefined });
        this.props.multiVar._firstVarId = variable._id;
        const matchingViews = ModuleFE_DiseaseView.cache.filter(item => ModuleFE_DiseaseView.canVariableBeAddedToView(item, this.props.multiVar));
        const diseaseView = matchingViews.length ? matchingViews[0] : undefined;
        if (diseaseView)
            this.applyDiseaseViewOnMultiVar(diseaseView);
        this.reDeriveState({ tags: undefined, diseaseView, isChief: Dialog_MultiVar_Editor.isChief(this.props) });
    };
    onAttributeSelected = (variable) => {
        this.props.multiVar.variables[this.state.editingIndex] = {
            variableId: variable._id,
            tagIds: [],
        };
        // if (this.props.attributeeIndex !== -1)
        // 	this.props.multiVar.variables[this.state.editingIndex].attributeeId = this.props.multiVar.variables[this.props.attributeeIndex!].variableId;
        this.reDeriveState({ tags: undefined });
    };
    onDiseaseViewSelected = (diseaseView) => {
        this.applyDiseaseViewOnMultiVar(diseaseView);
        this.reDeriveState({ diseaseView });
    };
    applyDiseaseViewOnMultiVar(diseaseView) {
        const dvTagId = ConfigKeyFE_DiseasesViewsTagId.get();
        const dvGroup = this.props.multiVar.variables[this.state.editingIndex].tagIds.find(i => i.key === dvTagId);
        if (!dvGroup) {
            this.props.multiVar.variables[this.state.editingIndex].tagIds.push({
                key: dvTagId,
                value: diseaseView.enforcedTags
            });
        }
        else {
            dvGroup.value = diseaseView.enforcedTags;
        }
    }
    closeDialog = () => {
        ModuleFE_Dialog.close();
    };
    isEditing() {
        return this.props.multiVar._id || !!this.props.attributeOrColumnIndex;
    }
    canBeSaved = () => {
        if (this.getSelectedMultivarVariable()?.variableId === undefined)
            return false;
        if (this.state.editingIndex === 0 && !this.state.diseaseView)
            return false;
        return true;
    };
    getSelectedVariable = () => {
        if (!this.getSelectedMultivarVariable())
            return undefined;
        return ModuleFE_Variable.cache.unique(this.getSelectedMultivarVariable().variableId);
    };
    getSelectedAttribute = () => {
        if (this.state.editingIndex !== 0)
            return undefined;
        return ModuleFE_Variable.cache.unique(this.props.multiVar.variables[1]?.variableId);
    };
    getSelectedMultivarVariable() {
        return this.props.multiVar.variables[this.state.editingIndex];
    }
    async deleteImpl() {
        const multiVar = this.props.multiVar;
        await ModuleFE_MultiVar.v1.delete(multiVar).executeSync();
        this.logInfo(this.state.isChief);
        if (this.state.isChief) {
            const dp = ModuleFE_DiseaseProfile.cache.unique(multiVar.diseaseProfileId);
            if (!dp)
                throw new MUSTNeverHappenException(`cannot find dp with id ${multiVar.diseaseProfileId}`);
            if (!ModuleFE_MultiVar.cache.filter(mv => (mv._firstVarId === multiVar._firstVarId) && (mv.diseaseProfileId === multiVar.diseaseProfileId)).length)
                removeItemFromArray(dp.chiefComplaintIds, multiVar._firstVarId);
            return ModuleFE_DiseaseProfile.v1.upsert(dp).executeSync();
        }
    }
    onDelete = async () => {
        //Set busy dialog
        this.setState({ dialogIsBusy: true });
        //If removing a column
        if (this.state.editingIndex > 0) {
            await performAction(async () => {
                try {
                    removeFromArrayByIndex(this.props.multiVar.variables, this.state.editingIndex);
                    await this.saveImpl();
                    this.closeDialog();
                }
                catch (e) {
                    this.setState({ dialogIsBusy: false });
                }
            }, { type: 'notification', notificationLabels: 'Removing Attribute' });
            return;
        }
        //If deleting the multivar
        this.logInfo('MV to Delete:', this.props.multiVar);
        let multivarTextualView = '';
        multivarTextualView += ModuleFE_DiseaseProfile.cache.unique(this.props.multiVar.diseaseProfileId).label;
        multivarTextualView += ' - ' + this.props.diseaseView?.label;
        multivarTextualView += ' - ' + ModuleFE_Variable.cache.unique(this.props.multiVar._firstVarId).name;
        await performAction(async () => {
            try {
                await this.deleteImpl();
                this.closeDialog();
            }
            catch (e) {
                console.log('Im HERE');
                console.log(e);
                this.setState({ dialogIsBusy: false });
                throw e;
            }
        }, {
            type: 'toast',
            successContent: _jsx(QToastContent, { content: 'MultiVar deleted successfully', toastType: 'success', iconKey: 'v' }),
            duration: 10000,
        }, multivarTextualView, true);
    };
    static isChief = (props) => {
        return ModuleFE_DiseaseProfile.cache.unique(props.multiVar.diseaseProfileId).chiefComplaintIds.includes(props.multiVar._firstVarId);
    };
    async saveImpl() {
        const variables = this.props.multiVar.variables;
        // if we are dealing with adding an attribute to another var in the multivar
        // const attributeeIndex: number | undefined = this.props.attributeeIndex;
        // if (attributeeIndex && attributeeIndex >= 0)
        // 	variables[this.state.editingIndex].attributeeId = variables[attributeeIndex].variableId;
        variables[this.state.editingIndex].tagIds = VariableWrapper.getTagsForDB(this.state.tags);
        let multivar;
        try {
            multivar = await ModuleFE_MultiVar.v1.upsert(this.props.multiVar).executeSync();
        }
        catch (e) {
            handleError(e);
        }
        if (this.state.isChief !== undefined) {
            const diseaseProfile = cloneObj(ModuleFE_DiseaseProfile.cache.unique(this.props.multiVar.diseaseProfileId));
            diseaseProfile.chiefComplaintIds = diseaseProfile.chiefComplaintIds || [];
            if (this.state.isChief) {
                //If multivar is already chief - return
                if (diseaseProfile.chiefComplaintIds.includes(multivar._firstVarId))
                    return;
                diseaseProfile.chiefComplaintIds.push(multivar._firstVarId);
                filterDuplicates(diseaseProfile.chiefComplaintIds);
            }
            else {
                //If multivar is already not chief - return
                if (!diseaseProfile.chiefComplaintIds.includes(multivar._firstVarId))
                    return;
                diseaseProfile.chiefComplaintIds = diseaseProfile.chiefComplaintIds.filter(id => id !== multivar._firstVarId);
            }
            try {
                await ModuleFE_DiseaseProfile.v1.upsert(diseaseProfile).executeSync();
            }
            catch (e) {
                handleError(e);
            }
        }
    }
    onSave = async () => {
        this.logInfo('MV to save:', this.props.multiVar);
        await performAction(async () => {
            this.setState({ dialogIsBusy: true });
            await this.saveImpl();
            this.setState({ dialogIsBusy: false }, () => ModuleFE_Dialog.close());
            this.setState({ dialogIsBusy: false });
        }, { type: 'notification', notificationLabels: 'Updating Multivar' });
    };
    onDisabledClick = async (e) => {
        if (!this.state.diseaseView)
            ModuleFE_Toaster.toastError('Please pick a disease view');
    };
    //######################### Render #########################
    renderHeader = () => {
        return _jsxs(_Fragment, { children: [_jsx("span", { className: 'header__title', children: this.isEditing() ? 'Edit Multivar' : 'Add MultiVar' }), _jsx("div", { className: 'header__buttons', children: _jsx(ICONS.x.component, { className: "exit_icon", onClick: this.closeDialog }) })] });
    };
    renderBody = () => {
        if (this.props.attributeeIndex !== undefined)
            return _jsxs(_Fragment, { children: [this.renderAttributeeVariable(), this.renderColumnOrAttributeDropdown(), this.renderTags(this.state.tags, this.getSelectedVariable())] });
        return _jsxs(_Fragment, { children: [this.renderVariableDropDown(), this.renderDP_ViewConfig(), this.renderAttributeDropdown(), this.renderChiefCheckbox(), this.renderViews(), this.renderTags(this.state.tags, this.getSelectedVariable())] });
    };
    buttons = () => {
        const buttons = {
            right: [
                { content: 'Cancel', onClick: this.closeDialog },
                {
                    content: 'Save',
                    onClick: this.onSave,
                    onDisabledClick: this.onDisabledClick,
                    className: 'desired-action-button',
                    disabled: !this.canBeSaved() || this.state.dialogIsBusy,
                }
            ]
        };
        if (this.props.multiVar?._id)
            buttons.left = [{
                    content: 'Delete',
                    className: 'delete-button',
                    disabled: this.state.dialogIsBusy,
                    onClick: this.onDelete
                }];
        return buttons;
    };
    renderTags(tags, variable) {
        const tagIds = variable?.tagIds;
        if (!tagIds)
            return;
        const allowedGroupTags = tagIds.map(group => group.key);
        const allowedTags = flatArray(tagIds.map(group => group.value));
        const dp = ModuleFE_DiseaseProfile.cache.unique(this.props.multiVar.diseaseProfileId);
        if (dp?.variantsGroupId) {
            const group = ModuleFE_Tag.cache.unique(dp.variantsGroupId);
            if (!group)
                throw new BadImplementationException(`Variant group with id ${dp.variantsGroupId} does not exist`);
            const tags = ModuleFE_Tag.cache.filter(i => i.tagIds.includes(group._id));
            allowedGroupTags.push(group._id);
            allowedTags.push(...tags.map(dbObjectToId));
        }
        const diseaseViewTagId = ConfigKeyFE_DiseasesViewsTagId.get();
        const diseaseProfile = ModuleFE_DiseaseProfile.cache.unique(this.props.multiVar.diseaseProfileId);
        const globalTagGroups = filterInstances([diseaseProfile.variantsGroupId, diseaseViewTagId]);
        return _jsx(Component_TagEditor, { tags: tags, singleTagFilter: (tag, groupTag) => tag.tagIds[0] === groupTag._id && (allowedTags.includes(tag._id) || globalTagGroups.includes(tag.tagIds[0])), groupTagFilter: (groupTag) => allowedGroupTags.includes(groupTag._id) || globalTagGroups.includes(groupTag._id) });
    }
    //######################### Render - Editing Main Variable #########################
    renderDP_ViewConfig() {
        if (this.state.editingIndex !== 0)
            return '';
        if (this.isEditing() && this.state.diseaseView)
            return _jsxs(LL_V_L, { className: 'match_width', children: [_jsx("div", { className: 'dialog__field-title', children: "Selected Disease View" }), _jsx("div", { children: this.state.diseaseView.label })] });
        return _jsxs(LL_V_L, { className: 'match_width', children: [_jsx("div", { className: 'dialog__field-title', children: "Select Disease View" }), _jsx(DPDropDowns.DiseaseView, { selected: this.state.diseaseView, onSelected: this.onDiseaseViewSelected, queryFilter: view => {
                        return ModuleFE_DiseaseView.canVariableBeAddedToView(view, this.props.multiVar);
                    } })] });
    }
    renderVariableDropDown = () => {
        return _jsxs(LL_V_L, { className: 'match_width', children: [_jsx("div", { className: 'dialog__field-title', children: "Select Variable" }), _jsx(Component_VariableSelector, { onVariableSelected: this.onVariableSelected, selectedVariableId: this.getSelectedVariable()?._id, queryFilter: (variable) => {
                        // do not allow attributes
                        // if (variable.isAttribute)
                        // 	return false;
                        // do not allow variables that already exists in this multivar)
                        if (this.props.multiVar.variables.find(mvv => mvv.variableId === variable._id))
                            return false;
                        // do not allow variables that already have multivars associated with them)
                        // return !ModuleFE_MultiVar.cache.find(item => item.variables[0].variableId === variable._id && item.diseaseProfileId === this.props.multiVar.diseaseProfileId);
                        return true;
                    }, allowSelection: !this.isEditing() })] });
    };
    renderAttributeDropdown = () => {
        const variable = ModuleFE_Variable.cache.unique(this.props.multiVar.variables[this.state.editingIndex]?.variableId);
        //Don't render if not dealing with first variable or if the first variable doesn't have attributes
        if (this.state.editingIndex !== 0 || !variable || !variable.attributes)
            return '';
        //Don't render if editing and the second variable doesn't exist OR is not an attribute of the first
        // if (this.isEditing() && this.props.multiVar.variables[1]?.attributeeId !== variable._id)
        // 	return '';
        const attributes = variable.attributes.map(att => att.varId);
        return _jsxs(LL_V_L, { className: 'match_width', children: [_jsx("div", { className: 'dialog__field-title', children: "Select Attribute" }), _jsx(Component_VariableSelector, { onVariableSelected: item => {
                        this.props.multiVar.variables[1] = {
                            variableId: item._id,
                            tagIds: item.tagIds,
                        };
                        this.forceUpdate();
                    }, selectedVariableId: this.getSelectedAttribute()?._id, queryFilter: item => attributes.includes(item._id), allowSelection: !this.isEditing() })] });
    };
    renderViews = () => {
        if (this.state.editingIndex !== 0)
            return '';
        const multiVar = this.props.multiVar;
        const variable = this.getSelectedVariable();
        if (!multiVar || !variable)
            return '';
        let views = ModuleFE_DiseaseView.cache.all();
        views = views.filter(view => ModuleFE_DiseaseView.canVariableBeAddedToView(view, multiVar));
        return _jsxs(LL_V_L, { className: 'match_width', style: { gap: '10px' }, children: [_jsx("div", { className: 'dialog__field-title', children: "Matching Views" }), _jsx(LL_H_C, { className: 'dialog__field-content views', children: views.map(view => {
                        return _jsx("div", { className: 'view', children: view.label }, view._id);
                    }) })] });
    };
    renderChiefCheckbox = () => {
        const variable = this.getSelectedVariable();
        // TODO replace with app config
        const complaintTagId = ModuleFE_Tag.cache.find(item => item.label.toLowerCase() === 'complaints')._id;
        if (!variable?._tagIds.includes(complaintTagId))
            return '';
        return _jsxs(LL_H_C, { className: 'dialog__main__section horizontal match_width no-grow', style: { justifyContent: 'space-between' }, children: [_jsx("label", { children: "Is this complaint a chief complaint?" }), _jsx(TS_Radio, { className: 'label-radio', values: ['No', 'Yes'], groupName: 'is-chief-complaint', checked: this.state.isChief ? 'Yes' : 'No', onCheck: val => {
                        this.setState({ isChief: val === 'Yes' });
                    } })] });
    };
    //######################### Render - Editing Column / Attribute #########################
    renderAttributeeVariable = () => {
        if (this.props.attributeeIndex === -1)
            return '';
        const multiVar = this.props.multiVar;
        return _jsxs(LL_V_L, { className: 'match_width', children: [_jsx("div", { className: 'dialog__field-title', children: "Attributee" }), _jsx(Component_VariableSelector, { onVariableSelected: voidFunction, selectedVariableId: multiVar.variables[this.props.attributeeIndex].variableId, allowSelection: false })] });
    };
    renderColumnOrAttributeDropdown = () => {
        const multiVar = this.props.multiVar;
        return _jsxs(LL_V_L, { className: 'match_width', children: [_jsx("div", { className: 'dialog__field-title', children: "Select Variable" }), _jsx(Component_VariableSelector, { onVariableSelected: this.onAttributeSelected, selectedVariableId: multiVar.variables[this.state.editingIndex]?.variableId, queryFilter: v => {
                        return true;
                        // if (multiVar.variables.find(mvv => mvv.variableId === v._id && mvv.attributeeId === this.props.multiVar.variables[this.props.attributeeIndex!]?.variableId))
                        // 	return false;
                        //
                        // if (this.props.attributeeIndex === -1)
                        // 	return !v.isAttribute;
                        //
                        // return !!v.isAttribute;
                    }, allowSelection: !this.props.attributeOrColumnIndex })] });
    };
}
//# sourceMappingURL=Dialog_MultiVar_Editor.js.map